module.exports = __webpack_public_path__ + "img/service6.4a3f2521.png";